module.exports = __webpack_public_path__ + "static/media/img_fenlei09.79769e08.png";